import React from "react"
import { useIntl } from "react-intl"
import { PageLayout } from "#/features/global-ui/page-layout"
import { PageHeader } from "#/features/global-ui/page-header"
import Settings from "#/utils/CarrotConfig"
import { Box, Progress } from "@carrotfertility/carotene-core"

// The consumer package is code-split and lazy-loaded (mirroring Root.tsx), so none of the
// package's billing code loads until a signed-in member navigates to this page. React.lazy
// infers the route's prop types from the dynamic import.
const ConsumerSubscriptionBillingRoute = React.lazy(() =>
  import("@internal/consumer").then((m) => ({ default: m.ConsumerSubscriptionBillingRoute }))
)

export default function ConsumerSubscriptionBillingPage(): JSX.Element {
  const intl = useIntl()
  return (
    <PageLayout header={<PageHeader pageTitle={intl.formatMessage({ defaultMessage: "Billing detail" })} />}>
      <React.Suspense
        fallback={
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              blockSize: 200
            }}
          >
            <Progress />
          </Box>
        }
      >
        {/* This host page only mounts for authenticated members (routed inside the authed
            NavLayout chrome), so `isLoggedIn` is always true here. */}
        <ConsumerSubscriptionBillingRoute isLoggedIn={true} stripePublishableKey={Settings.STRIPE_PUBLISHABLE_KEY} />
      </React.Suspense>
    </PageLayout>
  )
}
